import {
  Button,
  Drawer,
  Form,
  Input,
  InputNumber,
  Select,
  Space,
  Upload,
} from "antd";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../context";
import TextArea from "antd/es/input/TextArea";
// import { NotificationInfo, UserInfo } from "../../../../context";
// import { NotificationInfo, UserInfo } from "../../../context";

const AddStoreAdmin = ({ open, close, setLoading, rerun }) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  const [fileList, setFileList] = useState([{}]);
  const [provinceList, setProvinceList] = useState({ data: [], ready: false });
  const [cityList, setCityList] = useState({ data: [], ready: false });
  const [barangayList, setBarangayList] = useState({ data: [], ready: false });

  const handleSaveToProduct = (values) => {
    // console.log("values", values);
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);

    for (const name in values) {
      formdata.append(name, values[name]);
    }
    setLoadings(true);
    setLoading(true);
    axios
      .post("user/admin/create/new-store-admin", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "exceed-limit") {
          rerunNotif("error", "Exceed limit.");
          setTimeout(() => {
            setLoadings(false);
            setLoading(false);
          }, 1000);
        }
        if (data === "success") {
          rerunNotif("success", "Created store admin successfully.");
          setTimeout(() => {
            close();
            setLoadings(false);
            setLoading(false);
            rerun();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  const getAllProvinces = () => {
    axios
      .get("user/merchant/province-list")
      .then((response) => {
        const data = response.data;
        setProvinceList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  const handleGetCityByProvince = (value) => {
    var params = { province_description: value };
    setCityList({ data: [], ready: false });
    setBarangayList({ data: [], ready: false });
    axios
      .get("user/merchant/city-list", { params })
      .then((response) => {
        const data = response.data;
        setCityList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  const handleGetBarangayByCity = (value) => {
    var params = { city_municipality_description: value };
    setBarangayList({ data: [], ready: false });
    axios
      .get("user/merchant/barangay-list", { params })
      .then((response) => {
        const data = response.data;
        setBarangayList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  useEffect(() => {
    getAllProvinces();
  }, []);

  //   const handleChange = (info) => {
  //     // console.log(info);
  //     let fileList = [...info.fileList];
  //     fileList = fileList.slice(-1);
  //     // console.log("fileList", fileList);
  //     setFileList(fileList);
  //   };

  return (
    <Drawer
      title="Create Store Admin"
      // width={500}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      <Form
        layout="vertical"
        name="add-store"
        initialValues={{
          product: "",
          description: "",
          price: "",
        }}
        onFinish={handleSaveToProduct}
        autoComplete="off"
      >
        <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
          <Form.Item
            name="firstname"
            label="Firstname"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input placeholder="Set firstname" size="large" />
          </Form.Item>

          <Form.Item
            name="lastname"
            label="Lastname"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input placeholder="Set lastname" size="large" />
          </Form.Item>

          <Form.Item
            name="contact_no"
            label="Contact #"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input placeholder="Set contact #" size="large" />
          </Form.Item>

          <Form.Item
            name="province"
            label="Province"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select
              //   placeholder="SELECT PROVINCE"
              onChange={handleGetCityByProvince}
              size="large"
              showSearch
            >
              {provinceList.data.length > 0 ? (
                provinceList.data.map((data, index) => (
                  <Select.Option value={data.province_description} key={index}>
                    {data.province_description}
                  </Select.Option>
                ))
              ) : (
                <Select.Option value="">No province found!</Select.Option>
              )}
            </Select>
          </Form.Item>

          <Form.Item
            name="city"
            label="City"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select
              //   placeholder="SELECT CITY"
              onChange={handleGetBarangayByCity}
              size="large"
              showSearch
            >
              {cityList.data.length > 0 ? (
                cityList.data.map((data, index) => (
                  <Select.Option
                    value={data.city_municipality_description}
                    key={index}
                  >
                    {data.city_municipality_description}
                  </Select.Option>
                ))
              ) : (
                <Select.Option value="">No city found!</Select.Option>
              )}
            </Select>
          </Form.Item>

          <Form.Item
            name="barangay"
            label="Barangay"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select
              //   placeholder="Select barangay"
              size="large"
              showSearch
              style={{ textTransform: "uppercase" }}
            >
              {barangayList.data.length > 0 ? (
                barangayList.data.map((data, index) => (
                  <Select.Option
                    value={data.barangay_description}
                    key={index}
                    style={{ textTransform: "uppercase" }}
                  >
                    {data.barangay_description}
                  </Select.Option>
                ))
              ) : (
                <Select.Option value="">No barangay found!</Select.Option>
              )}
            </Select>
          </Form.Item>

          <Form.Item
            name="street"
            label="Street|House No.|Bldg. No.|Apartment"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <TextArea
              //   placeholder="Set Street| House No.| Bldg. No."
              autoSize
              size="large"
              //   style={{ textTransform: "uppercase" }}
            />
          </Form.Item>

          <Form.Item
            name="username"
            label="Username"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input placeholder="Set username" size="large" />
          </Form.Item>

          <Form.Item
            name="password"
            label="Password"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input placeholder="Set password" size="large" />
          </Form.Item>
        </Space>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            loading={loadings}
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            {loadings ? "Loading" : "Create"}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default AddStoreAdmin;
